import { useState, useMemo } from "react";
import { ContestRegistration } from "./useContestData";

export const useContestFilters = (registrations: ContestRegistration[]) => {
  const [selectedAcademy, setSelectedAcademy] = useState<string>("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState<Date | undefined>(undefined);
  const [endDate, setEndDate] = useState<Date | undefined>(undefined);

  const filteredRegistrations = useMemo(() => {
    return registrations.filter((reg) => {
      // Filter by academy
      if (selectedAcademy !== "all" && reg.academy !== selectedAcademy) {
        return false;
      }

      // Filter by search term
      if (searchTerm) {
        const search = searchTerm.toLowerCase();
        const matchesSearch =
          reg.school_name.toLowerCase().includes(search) ||
          reg.teacher_name.toLowerCase().includes(search) ||
          reg.teacher_email.toLowerCase().includes(search) ||
          reg.class_name.toLowerCase().includes(search) ||
          reg.school_city.toLowerCase().includes(search);
        if (!matchesSearch) return false;
      }

      // Filter by date range
      if (startDate) {
        const regDate = new Date(reg.created_at);
        if (regDate < startDate) return false;
      }
      if (endDate) {
        const regDate = new Date(reg.created_at);
        const endOfDay = new Date(endDate);
        endOfDay.setHours(23, 59, 59, 999);
        if (regDate > endOfDay) return false;
      }

      return true;
    });
  }, [registrations, selectedAcademy, searchTerm, startDate, endDate]);

  const handleAcademyChange = (academy: string) => {
    setSelectedAcademy(academy);
  };

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleStartDateChange = (date: Date | undefined) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date: Date | undefined) => {
    setEndDate(date);
  };

  return {
    selectedAcademy,
    searchTerm,
    startDate,
    endDate,
    filteredRegistrations,
    handleAcademyChange,
    handleSearchChange,
    handleStartDateChange,
    handleEndDateChange,
  };
};
